import { useQuery } from "react-query";
import { MRT_PaginationState } from "mantine-react-table";
import getBalancesListing, {
  BalancesListingResponse,
} from "../services/getBalancesListing";
function useGetBalancesListing(
  token: string,
  externalAccount: string,
  pagination: MRT_PaginationState,
  refreshKey: number
) {
  return useQuery<BalancesListingResponse>({
    queryKey: ["getBalancesListing", externalAccount, pagination, refreshKey], //refetch whenever the URL changes (pagination)
    queryFn: () => getBalancesListing({ token, externalAccount, pagination }),
    retry: false,
    keepPreviousData: true, //useful for paginated queries by keeping data from previous pages on screen while fetching the next page
    staleTime: 30_000, //don't refetch previously viewed pages until cache is more than 30 seconds old
  });
}

export default useGetBalancesListing;
